import { Tooltip, Typography, TypographyProps } from '@mui/material';
import React, { useCallback, useRef, useState } from 'react';

const EllipsesTypography: React.FC<TypographyProps> = ({
	children = null,
	sx,
	...props
}) => {
	const typographyRef = useRef<HTMLElement>(null);
	const [hide, setHide] = useState<undefined | boolean>(false);

	/* istanbul ignore next: cannot test this  */
	const onOpen = useCallback(() => {
		if (!typographyRef.current) {
			return;
		}

		if (typographyRef.current.offsetWidth < typographyRef.current.scrollWidth) {
			setHide(false);
			return;
		}

		setHide(true);
	}, []);

	return (
		<Tooltip
			onOpen={onOpen}
			title={children}
			enterDelay={500}
			slotProps={{
				transition: { style: hide ? { display: 'none' } : {} }
			}}
		>
			<Typography
				ref={typographyRef}
				sx={{
					textWrap: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					...sx
				}}
				{...props}
			>
				{children}
			</Typography>
		</Tooltip>
	);
};

export default EllipsesTypography;
